"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _draftExtend = require("draft-extend");

var _draftJs = require("draft-js");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _FileManagerApi = require("../api/FileManagerApi");

var _changeBlockData = _interopRequireDefault(require("../utils/changeBlockData"));

var _createImageMetadata = _interopRequireDefault(require("../utils/createImageMetadata"));

var _insertAtomicBlockWithData = _interopRequireDefault(require("../utils/insertAtomicBlockWithData"));

var _removeBlock = _interopRequireDefault(require("../utils/removeBlock"));

var isImageFile = function isImageFile(file) {
  return /image\//.test(file.type);
};

var blockExists = function blockExists(block, editorState) {
  return !!editorState.getCurrentContent().getBlockForKey(block.getKey());
};

var getBlockByImageSrc = function getBlockByImageSrc(url, editorState) {
  return editorState.getCurrentContent().getBlockMap().find(function (block) {
    return block.getData().getIn(['image', 'src']) === url;
  });
};

var emptyFunction = function emptyFunction() {};

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$onNonImageUpload = _ref.onNonImageUploadStarted,
      onNonImageUploadStarted = _ref$onNonImageUpload === void 0 ? emptyFunction : _ref$onNonImageUpload,
      _ref$onDropNonImage = _ref.onDropNonImage,
      onDropNonImage = _ref$onDropNonImage === void 0 ? emptyFunction : _ref$onDropNonImage,
      _ref$onNonImageUpload2 = _ref.onNonImageUploadFailed,
      onNonImageUploadFailed = _ref$onNonImageUpload2 === void 0 ? emptyFunction : _ref$onNonImageUpload2,
      _ref$fileOptions = _ref.fileOptions,
      fileOptions = _ref$fileOptions === void 0 ? {} : _ref$fileOptions;

  return function () {
    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    return function (WrappingComponent) {
      if (plugins.length === 0) {
        return WrappingComponent;
      }

      var pluginComposition = _draftExtend.compose.apply(void 0, plugins);

      var WrappedComponentWithPlugins = pluginComposition(WrappingComponent);

      if (WrappingComponent.prototype && WrappingComponent.prototype.isReactComponent) {
        var WithDropHandling = _react.default.createClass({
          displayName: "WithDropHandling",
          propTypes: {
            editorState: _react.PropTypes.instanceOf(_draftJs.EditorState).isRequired,
            handleDroppedFiles: _react.PropTypes.func,
            onChange: _react.PropTypes.func.isRequired
          },
          childContextTypes: {
            blur: _react.PropTypes.func,
            focus: _react.PropTypes.func
          },
          getChildContext: function getChildContext() {
            return {
              blur: this.blur,
              focus: this.focus
            };
          },
          getUploadProgressHandler: function getUploadProgressHandler(blockToUpdate) {
            var _this = this;

            return function (progress) {
              var _this$props = _this.props,
                  editorState = _this$props.editorState,
                  onChange = _this$props.onChange;

              if (!progress.lengthComputable) {
                return;
              }

              if (!blockExists(blockToUpdate, editorState)) {
                // block deleted by user before upload completed
                return;
              }

              var percentComplete = parseInt(progress.loaded / progress.total, 10) * 100;
              var updatedBlockData = blockToUpdate.getData().mergeDeep({
                image: {
                  uploadPercent: percentComplete
                }
              });
              onChange((0, _changeBlockData.default)({
                editorState: editorState,
                block: blockToUpdate,
                updatedBlockData: updatedBlockData,
                preserveSelection: true
              }));
            };
          },
          uploadImageToFileManager: function uploadImageToFileManager(tempUrl, file, editorState) {
            var blockToUpdate = getBlockByImageSrc(tempUrl, editorState);
            return (0, _FileManagerApi.uploadFile)(file, this.getUploadProgressHandler(blockToUpdate)).then(function (data) {
              var fileUrl = data.objects[0].url;
              var updatedBlockData = blockToUpdate.getData().mergeDeep({
                image: {
                  isTemporary: false,
                  uploadPercent: 100,
                  src: fileUrl
                }
              });
              var newestEditorState = editorState;

              if (!blockExists(blockToUpdate, newestEditorState)) {
                // block deleted by user before upload complete
                return null;
              }

              return (0, _changeBlockData.default)({
                editorState: newestEditorState,
                block: blockToUpdate,
                updatedBlockData: updatedBlockData,
                preserveSelection: true
              });
            });
          },
          uploadAndInsertImages: function uploadAndInsertImages(images, editorState) {
            var _this2 = this;

            if (images.length < 1) {
              return;
            }

            var _images$ = images[0],
                tempUrl = _images$.tempUrl,
                file = _images$.file;
            this.uploadImageToFileManager(tempUrl, file, editorState).then(function (newEditorState) {
              if (newEditorState) {
                _this2.props.onChange(newEditorState);
              }

              _this2.uploadAndInsertImages(images.slice(1), newEditorState);
            }).catch(function () {
              _FloatingAlertStore.default.addAlert({
                type: 'danger',
                message: _react.default.createElement(_FormattedMessage.default, {
                  message: "draftPlugins.imagePlugin.uploadFailedBody",
                  options: {
                    fileName: file.name
                  }
                }),
                titleText: _react.default.createElement(_FormattedMessage.default, {
                  message: "draftPlugins.imagePlugin.uploadFailedTitle"
                })
              });

              _this2.removeTempImage(tempUrl);

              _this2.uploadAndInsertImages(images.slice(1));
            });
          },
          removeTempImage: function removeTempImage(tempUrl) {
            var _this$props2 = this.props,
                editorState = _this$props2.editorState,
                onChange = _this$props2.onChange;
            var blockToRemove = getBlockByImageSrc(tempUrl, editorState);

            if (!blockToRemove) {
              return;
            }

            onChange((0, _removeBlock.default)(blockToRemove.getKey(), editorState));
          },
          insertTempImages: function insertTempImages(images) {
            var editorStateWithImages = images.reduce(function (editorStateAcc, _ref2) {
              var tempUrl = _ref2.tempUrl;
              var data = (0, _createImageMetadata.default)({
                isTemporary: true,
                src: tempUrl,
                uploadPercent: 10 // show a little bit of progress to start

              });
              var newContentState = (0, _insertAtomicBlockWithData.default)(editorStateAcc, data).getCurrentContent();
              return _draftJs.EditorState.set(editorStateAcc, {
                currentContent: newContentState
              });
            }, this.props.editorState); // add to undo stack

            var finalEditorState = _draftJs.EditorState.push(this.props.editorState, editorStateWithImages.getCurrentContent(), 'insert-fragment');

            this.props.onChange(finalEditorState);
            return finalEditorState;
          },
          handleNonImageDrop: function handleNonImageDrop(file) {
            var fileToUpload = {
              name: file.name,
              size: file.size,
              type: file.type
            };
            onNonImageUploadStarted((0, _immutable.Map)(fileToUpload));
            (0, _FileManagerApi.uploadFile)(file, fileOptions).then(function (data) {
              // use a Map because most consumers (namely CRM) wrap
              // API responses in Immutable Records
              var fileData = (0, _immutable.Map)(data.objects[0]);

              if (fileData && onDropNonImage) {
                fileData = fileData.merge({
                  originalName: fileToUpload.name
                });
                onDropNonImage(fileData);
              }
            }).catch(function (error) {
              return onNonImageUploadFailed(error, fileToUpload);
            });
          },
          handleDroppedFiles: function handleDroppedFiles(selectionState, files) {
            var _this3 = this;

            if (!files || files.length === 0) {
              return;
            }

            var imagesToUpload = [];
            files.forEach(function (file) {
              if (isImageFile(file)) {
                var tempUrl = URL.createObjectURL(file);
                imagesToUpload.push({
                  tempUrl: tempUrl,
                  file: file
                });
              } else {
                _this3.handleNonImageDrop(file);
              }
            });
            var editorState = this.insertTempImages(imagesToUpload); // wait for onChange call in insertTempImages to propagate

            this.uploadAndInsertImages(imagesToUpload, editorState);

            if (this.props.handleDroppedFiles) {
              this.props.handleDroppedFiles(selectionState, files);
            }
          },
          blur: function blur() {
            if (this._child.blur) {
              this._child.blur();
            }
          },
          focus: function focus() {
            if (this._child.focus) {
              this._child.focus();
            }
          },
          render: function render() {
            var _this4 = this;

            return _react.default.createElement(WrappedComponentWithPlugins, (0, _extends2.default)({}, this.props, {
              handleDroppedFiles: this.handleDroppedFiles,
              ref: function ref(c) {
                return _this4._child = c;
              }
            }));
          }
        });

        return WithDropHandling;
      }

      return WrappedComponentWithPlugins;
    };
  };
};

exports.default = _default;
module.exports = exports.default;